import { render, staticRenderFns } from "./Reserva.vue?vue&type=template&id=28eb991e"
import script from "./Reserva.vue?vue&type=script&lang=js"
export * from "./Reserva.vue?vue&type=script&lang=js"
import style0 from "./Reserva.vue?vue&type=style&index=0&id=28eb991e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports